import { useState, createRef } from 'react';
import { useMount } from 'ahooks';
import css from './index.module.scss';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltapro/h5/');

interface TabItem {
    img1: string;
    img2: string;
    title: string;
    content: string;
}

const tabList: TabItem[] = [
    {
        img1: 'section17_1_1',
        img2: 'section17_1_2',
        title: '青森ねぶた祭',
        content:
            'これまではガソリン発電機を使って山車灯篭のライトアップをしていましたが、2022年の青森ねぶた祭では、DELTA Proを代替品として導入。太陽光発電で充電した電力を使用した初の脱炭素ねぶたを実現しました。ねぶた祭の関係者の方から、ガソリン発電機より軽く、グリーンエネルギーで排気ガスがないと、ご好評をいただきました。',
    },
    {
        img1: 'section17_2_1',
        img2: 'section17_2_2',
        title: 'MIND TRAIL SONI',
        content:
            'MIND TRAILは奈良県南部·東部に位置する奥大和を舞台に、雄大な自然を作品を通して体験する唯一無二の芸術祭。電気が通っていない森の中で、DELTA Proとダブルボルテージハブで200V電源を必要とする業務用プロジェクターを稼働し、自然と融合したプロジェクションマッピングを上映しました。',
    },
    {
        img1: 'section17_3_1',
        img2: 'section17_3_2',
        title: '建設現場の仮設事務所',
        content:
            '電源が整備されていない建設現場では、DELTA Proが仮設電源として、事務所全体の電力供給に使用できます。照明や事務機器から、部屋のエアコンまで電力を安定して供給することが可能です。エクストラバッテリーを自由に組み合わせることもできるので、必要に応じて容量を選択できます。',
    },
];

export default function TabInfo() {
    const [tabIndex, setTabIndex] = useState(0);
    const boxWithline = createRef<HTMLDivElement>();
    const imgRef = createRef<HTMLDivElement>();
    const innerBox = createRef<HTMLDivElement>();
    const [tabPosition, setTabPosition] = useState({
        tabWidth: 0,
        offsetLeft: 0,
    });

    const handleTabClick = (e: any) => {
        const { clientWidth, offsetLeft } = e.target;

        let left = offsetLeft;
        if (boxWithline.current && imgRef.current) {
            const contentWidth = imgRef.current?.clientWidth;
            const innerBoxWidth = boxWithline.current?.offsetWidth;
            if (innerBoxWidth - offsetLeft < contentWidth) {
                left = innerBoxWidth - contentWidth;
            }
        }

        if (boxWithline.current) {
            const scrollBox = boxWithline.current.parentElement;
            if (scrollBox) {
                scrollBox.scrollLeft = left;
            }
        }

        setTabIndex(e.target.dataset.index);
        setTabPosition({ tabWidth: clientWidth, offsetLeft: offsetLeft });
        e.preventDefault();
    };

    useMount(() => {
        const firstChild = innerBox.current?.firstElementChild;
        if (firstChild) {
            setTabPosition({ tabWidth: firstChild.clientWidth, offsetLeft: 0 });
        }
    });

    return (
        <div className={css.tab_info}>
            <div className="sub-title">家庭内のみではなく、</div>
            <div className="main-title">屋外イベント、 建設現場などでも大活躍</div>
            <div className="img-box">
                <div className="img-item" ref={imgRef}>
                    <EFPic name={[`${tabList[tabIndex].img1}.webp`, `${tabList[tabIndex].img1}.jpg`]} alt="" />
                </div>
                <div className="img-item">
                    <EFPic name={[`${tabList[tabIndex].img2}.webp`, `${tabList[tabIndex].img2}.jpg`]} alt="" />
                </div>
            </div>
            <div className="tab-box">
                <div className="tab-title-box">
                    <div ref={boxWithline} className="box-with-line">
                        <div className="inner-box" ref={innerBox}>
                            {tabList.map((item: TabItem, key: number) => (
                                <div className="tab-title-item" key={item.title} onClick={handleTabClick} data-index={key}>
                                    {item.title}
                                </div>
                            ))}
                        </div>
                        <div
                            className="line"
                            style={{
                                width: `calc(${tabPosition.tabWidth}px)`,
                                transform: `translateX(${tabPosition.offsetLeft}px)`,
                            }}
                        ></div>
                    </div>
                </div>
                <div className="content">
                    {tabList.map((item: TabItem, index: number) => (
                        <div className="content-item" key={item.title} style={{ display: tabIndex == index ? 'block' : 'none' }}>
                            {item.content}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
